<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="剧名" prop="videoName">
                <a-input v-model="queryParam.videoName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="ID" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="分类" prop="tagIds">
                <a-select v-model="queryParam.tagIds" placeholder="请选择" allow-clear>
                  <a-select-option v-for="(tag, index) in tagList" :key="index" :value="tag.id">
                    {{ tag.tagTitle }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="标签" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                  <a-select-option value="0">无标签</a-select-option>
                  <a-select-option value="1">NEW</a-select-option>
                  <a-select-option value="2">HOT</a-select-option>
                  <a-select-option value="3">首播</a-select-option>
                  <a-select-option value="4">独播</a-select-option>
                  <a-select-option value="5">FREE</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="上映状态" prop="isRelease">
                <a-select v-model="queryParam.isRelease" placeholder="请选择" allow-clear>
                  <a-select-option value="0">否</a-select-option>
                  <a-select-option value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting :style="{ float: 'right' }" v-model="columns" :refresh-loading="loading" @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <img
          slot="coverUrl"
          slot-scope="text, record"
          style="width: 48px; height: 48px"
          :preview="record.coverUrl"
          v-image-preview
          :src="record.coverUrl"
        />

        <span slot="updateCntName" slot-scope="text">
          {{ text || '暂无' }}
        </span>

        <span slot="fakeLookNum" slot-scope="text, record">
          <a-input-number
            :min="0"
            :precision="0"
            @keyup.enter="editNum(record)"
            v-model="record.fakeLookNum"
          ></a-input-number>
        </span>

        <span slot="fakeCollectNum" slot-scope="text, record">
          <a-input-number
            :min="0"
            :precision="0"
            @keyup.enter="editNum(record)"
            v-model="record.fakeCollectNum"
          ></a-input-number>
        </span>

        <!-- <span slot="operation" slot-scope="text, record">
          
        </span> -->
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVideo, editSort, editTrendingSort, delVideo, changeIsOpen } from '@/api/video/video'
import { listTag } from '@/api/video/tag'
import request from '@/utils/request'

export default {
  name: 'Video',
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: true,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      tagList: [],
      total: 0,
      // 查询参数
      queryParam: {
        id: null,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        goldPrice: null,
        describe: null,
        tagIds: null,
        type: null,
        isRelease: null,
        totalNum: null,
        videoName: null,
        coverUrl: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '200px',
          align: 'center',
        },
        {
          title: '剧名',
          dataIndex: 'videoName',
          align: 'center',
        },
        {
          title: '封面图',
          dataIndex: 'coverUrl',
          align: 'center',
          scopedSlots: { customRender: 'coverUrl' },
        },
        {
          title: '观看次数',
          dataIndex: 'lookNum',
          align: 'center',
        },
        {
          title: '设置观看次数(按下回车键保存)',
          dataIndex: 'fakeLookNum',
          align: 'center',
          scopedSlots: { customRender: 'fakeLookNum' },
        },
        {
          title: '收藏次数',
          dataIndex: 'collectNum',
          align: 'center',
        },
        {
          title: '设置收藏次数(按下回车键保存)',
          dataIndex: 'fakeCollectNum',
          align: 'center',
          scopedSlots: { customRender: 'fakeCollectNum' },
        },
        {
          title: '操作人',
          dataIndex: 'updateCntName',
          align: 'center',
          scopedSlots: { customRender: 'updateCntName' }, // 添加这一行
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   align: 'center',
        // }
      ],
    }
  },
  created() {
    this.getList()
    this.getTagList()
  },
  methods: {
    editNum(record) {
      request({
        url: '/video/videos/updateDataDisplay',
        method: 'post',
        data: { id: record.id, fakeLookNum: record.fakeLookNum, fakeCollectNum: record.fakeCollectNum },
      }).then((response) => {
        this.$message.success('操作成功')
        this.getList();
      })
    },
    getTagList() {
      listTag().then((response) => {
        this.tagList = response.data
      })
    },
    /** 查询短剧列表 */
    getList() {
      this.loading = true
      request({
        url: '/video/videos/videoDataDisplay',
        method: 'get',
        params: this.queryParam,
      }).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        lookNum: undefined,
        limitNum: undefined,
        diamondPrice: undefined,
        goldPrice: undefined,
        describe: undefined,
        tagIds: undefined,
        totalNum: undefined,
        videoName: undefined,
        coverUrl: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
  },
}
</script>
